var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.92 14.09L13.94 7.133 19.928.928c.042.128.072.262.072.403v12.335c0 .149-.032.29-.08.424zm-7.938-7.014L10 8.629l-1.977-1.55-1.004-.785L.993.06C1.118.025 1.246 0 1.383 0h17.235c.136 0 .264.025.388.061L12.985 6.29l-1.003.786zM.08 14.09A1.255 1.255 0 0 1 0 13.666V1.331c0-.141.03-.275.072-.403l5.993 6.207L.079 14.09zM10 10.218l2.936-2.3 6.056 7.022a1.388 1.388 0 0 1-.373.057H1.382c-.13 0-.253-.024-.373-.056l6.06-7.02 2.93 2.297z",
    fillRule: "nonzero"
  })));
};
export default SvgEmail;